import { fileUrl } from "@/lib/api";
import { FileText, FileSpreadsheet, FileType2, File, FileArchive, X } from "lucide-react";

export const isImage = (a) => /^image\//.test(a?.type || "") || /\.(png|jpe?g|webp|gif|heic|heif)(\?|$)/i.test(a?.name || a?.url || "");
export const fmtSize = (n) => (!n ? "" : n < 1024 * 1024 ? `${Math.max(1, Math.round(n / 1024))} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`);

const meta = (a) => {
  const ext = String(a.name || a.url || "").split("?")[0].split(".").pop().toLowerCase();
  if (ext === "pdf") return { Icon: FileText, cls: "bg-red-50 text-red-600 border-red-200", label: "PDF" };
  if (["xls", "xlsx", "csv"].includes(ext)) return { Icon: FileSpreadsheet, cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Excel" };
  if (["doc", "docx"].includes(ext)) return { Icon: FileType2, cls: "bg-blue-50 text-blue-700 border-blue-200", label: "Word" };
  if (["zip", "rar", "7z"].includes(ext)) return { Icon: FileArchive, cls: "bg-amber-50 text-amber-700 border-amber-200", label: "Arşiv" };
  return { Icon: File, cls: "bg-muted text-muted-foreground border-border", label: ext ? ext.toUpperCase() : "Dosya" };
};

const RemoveBtn = ({ onClick, testid }) => (
  <button type="button" onClick={onClick} className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-foreground text-background flex items-center justify-center shadow hover:bg-destructive transition-colors" title="Kaldır" data-testid={testid}>
    <X className="h-3 w-3" />
  </button>
);

// Sohbet eki: görsel → küçük resim; dosya → ikonlu kart (PDF/Excel/Word/Arşiv/diğer)
export default function AttachmentCard({ a, onRemove, compact = false, mine = false, testid }) {
  if (isImage(a)) {
    return (
      <div className="relative inline-block" data-testid={testid}>
        {onRemove ? <img src={fileUrl(a.url)} alt={a.name || "görsel"} className="h-16 w-16 rounded-lg object-cover border" />
          : <a href={fileUrl(a.url)} target="_blank" rel="noreferrer"><img src={fileUrl(a.url)} alt={a.name || "görsel"} className="rounded-lg max-h-64 max-w-full object-contain bg-black/5" /></a>}
        {onRemove && <RemoveBtn onClick={onRemove} testid={testid ? `${testid}-remove` : undefined} />}
      </div>
    );
  }
  const { Icon, cls, label } = meta(a);
  return (
    <div className={`relative flex items-center gap-2.5 rounded-lg border px-2.5 py-2 ${compact ? "max-w-[220px]" : "min-w-[200px] max-w-[300px]"} ${mine ? "bg-white/10 border-white/25 text-white" : "bg-card"}`} data-testid={testid}>
      <span className={`h-9 w-9 rounded-md border flex items-center justify-center shrink-0 ${mine ? "bg-white/15 border-white/20 text-white" : cls}`}><Icon className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-xs font-semibold truncate" title={a.name}>{a.name || "Dosya"}</div>
        <div className={`text-[10px] ${mine ? "text-white/70" : "text-muted-foreground"}`}>{label}{a.size ? ` · ${fmtSize(a.size)}` : ""}</div>
      </div>
      {onRemove ? <RemoveBtn onClick={onRemove} testid={testid ? `${testid}-remove` : undefined} />
        : <a href={fileUrl(a.url)} target="_blank" rel="noreferrer" className={`text-[11px] font-bold underline shrink-0 ${mine ? "text-white" : "text-primary"}`} data-testid={testid ? `${testid}-open` : undefined}>Aç</a>}
    </div>
  );
}
